import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const AdkLinksTable = ({ links, onRemove, onUpdate }) => {
    const rows = links.map((link, index) => <Row key={index} link={link} onUpdate={onUpdate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Link</th>
                    <th>Platform</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkLinksTable;


// WEBPACK FOOTER //
// ./src/scenes/AdkLinks/components/Table/index.js